// src/services/modules/Tenencias.js
import { storage, db } from '../../../firebase'; // Configuración de Firebase
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, query, where, getDocs, addDoc, doc, deleteDoc } from 'firebase/firestore';



export const uploadFileToFirebase = async (file, dpi, serie) => {
    try {
        // Subir archivo al Storage
        const fileRef = ref(storage, `tenencias/${dpi}-${serie}-${file.name}`);
        await uploadBytes(fileRef, file);
        const fileUrl = await getDownloadURL(fileRef);

        // Guardar datos en Firestore
        const tenenciaData = {
            dpi,
            serie,
            fileUrl,
            createdAt: new Date(),
        };
        const docRef = await addDoc(collection(db, 'tenencias'), tenenciaData);

        console.log('Tenencia registrada con ID:', docRef.id);
        return fileUrl; // Devolver la URL del archivo
    } catch (error) {
        console.error('Error al subir archivo y registrar tenencia:', error);
        throw new Error('No se pudo registrar la tenencia.');
    }
};

export const fetchTenenciasByDpi = async (dpi) => {
    try {
        const q = query(collection(db, 'tenencias'), where('dpi', '==', dpi));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map((doc) => ({
            id: doc.id, // Incluye el ID del documento
            ...doc.data(),
        }));
    } catch (error) {
        console.error('Error al buscar tenencias por DPI:', error);
        throw error;
    }
};

export const fetchTenenciasBySerie = async (serie) => {
    try {
        const q = query(collection(db, 'tenencias'), where('serie', '==', serie));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map((doc) => ({
            id: doc.id, // Incluye el ID del documento
            ...doc.data(),
        }));
    } catch (error) {
        console.error('Error al buscar tenencias por Serie:', error);
        throw error;
    }
};
export const deleteTenencia = async (id) => {
    try {
        const docRef = doc(db, 'tenencias', id);
        await deleteDoc(docRef);
        console.log(`Documento con ID ${id} eliminado correctamente.`);
    } catch (error) {
        console.error('Error al eliminar la tenencia:', error);
        throw error;
    }
};
